import type { AxiosResponse } from 'axios';
import type { IFetchWebNotificationsRequest, INotificationRequest, IWebNotification } from '../../domain';
import { ApiBaseService } from '../api-base-service';

export class NotificationsApiService extends ApiBaseService {
    constructor(context = '/delegate/notifications/v2') {
        super(context);
    }

    async fetchWebNotifications(request: IFetchWebNotificationsRequest): Promise<{ notifications: IWebNotification[]; totalCount: number }> {
        const params = { ...request, 'source-module': (request['source-module'] || []).join(',') };

        return this.http
            .get<IWebNotification[]>(`/web-notifications`, { params })
            .then(({ data, headers }: AxiosResponse) => ({ notifications: data, totalCount: +headers['x-total-count'] }));
    }

    async sendNotification(notificationRequest: INotificationRequest): Promise<string> {
        return this.http.post<string>(`/notifications/notify`, notificationRequest).then((response) => response.data);
    }
}
